// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__9CevQ","load7":"LoadingSpinner_load7__uoltR"};